import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { DealerButton } from './dealerButton';
export const DealerButtonContainer = () => {
    const buttonSeatIndex = useAppSelector((state) => state.poker.buttonSeatIndex);
    const dealerButtonCoords = useAppSelector((state) => (buttonSeatIndex !== undefined ? state.gameDimensions.dealerButtonCoords[buttonSeatIndex] : undefined), shallowEqual);
    if (buttonSeatIndex === undefined || dealerButtonCoords === undefined) {
        return null;
    }
    const { x, y } = dealerButtonCoords;
    return _jsx(DealerButton, { seatIndex: buttonSeatIndex, x: Math.round(x), y: Math.round(y), size: 36 });
};
